/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { CookieService } from 'app/shared/services/cookie.service';
import { HttpClient } from '@angular/common/http';
import { SnackBarService } from 'app/shared/services/snack-bar.service';
import { UiStateService } from 'app/shared/services/ui-state.service';

@Injectable({providedIn: 'root'})
export class ApiDependenciesService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public snackBar: SnackBarService,
    public cookieService: CookieService,
    public uiStateService: UiStateService
  ) {}
}
